export default __webpack_public_path__ + "static/media/blue-arrow-right.0b1fc4e6.svg";